module.exports = __webpack_public_path__ + "img/award-2.fca0c318.png";